import { useMutation } from '@tanstack/react-query';
import { useApiClient } from '../api';
import { parseError } from '../utils/error-handler';
import type { CancelPaymentDto, CancelPaymentV2Request, ErrorMessage } from '../../generated-api';
import { useInitiateCancelAll, useInitiateCancelAppSwitch } from '@ordr-as/payment-service-types/epos';

export const useMutateCancelPayment = () => {
  const apiClient = useApiClient();
  return useMutation<CancelPaymentDto, ErrorMessage, CancelPaymentV2Request>({
    mutationFn: async (cancelPaymentRequest: CancelPaymentV2Request) =>
      apiClient.PaymentCancelledController.cancelPaymentV2(cancelPaymentRequest, {
        headers: { 'Content-Type': 'application/json' },
      }).catch(parseError),
  });
};

export const useMutateCancelAll = () => useInitiateCancelAll();
export const useMutateCancelAppSwitch = () => useInitiateCancelAppSwitch();
